import { Option } from '../../components/types';
import { StatusColor } from './statusColor';

export enum USER_STATUSES {
  invited = 'INVITED',
  unknown = 'UNKNOWN',
  active = 'ACTIVE',
  deactivated = 'DEACTIVATED',
}

export type USER_STATUS = 'ACTIVE' | 'INVITED' | 'DEACTIVATED';

export const USER_STATUS_MAP = {
  ACTIVE: StatusColor.GREEN,
  INVITED: StatusColor.GRAY,
  DEACTIVATED: StatusColor.RED,
};

export const ADMIN_PANEL_USER_STATUS = {
  ACTIVE: USER_STATUSES.active,
  DEACTIVATED: USER_STATUSES.deactivated,
  INVITED: USER_STATUSES.invited,
  EXPIRED: 'EXPIRED',
};

export const USER_STATUSES_OPTIONS: Option[] = [
  { value: ADMIN_PANEL_USER_STATUS.ACTIVE, label: 'Active' },
  { value: ADMIN_PANEL_USER_STATUS.DEACTIVATED, label: 'Deactivated' },
  { value: ADMIN_PANEL_USER_STATUS.INVITED, label: 'Invited' },
  { value: ADMIN_PANEL_USER_STATUS.EXPIRED, label: 'Expired' },
];
